export function NoSuchPage() {
  return (
    <>
      <h1>No Such Page</h1>
      <p>
        The requested page does not exist.
      </p>
    </>
  );
}
